"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const multi_valued_text_field_1 = require("../../../../../layouts/multi-valued-text-field");
const core_1 = require("@material-ui/core");
const react_redux_1 = require("react-redux");
const api_1 = require("../../../../../utils/api");
const react_spinners_1 = require("react-spinners");
const js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
function PreprocessingStep3AnomalyDetection(props) {
    const { setUpdatedInterpolateData, interpolationFrequencyError } = props;
    const projectInfo = react_redux_1.useSelector((state) => state.ProjectInfo);
    const interpolationDataSaved = react_redux_1.useSelector((state) => state.interpolationData);
    const selectedColumns = react_redux_1.useSelector((state) => state.columnSelectionS22);
    const [loading, setLoading] = react_1.useState(false);
    const [interpolationData, setInterpolationData] = react_1.useState({
        interpolationBase: interpolationDataSaved && interpolationDataSaved.interpolationBase || "",
        interpolationFrequency: interpolationDataSaved && interpolationDataSaved.interpolationFrequency || "5",
        labelColumn: interpolationDataSaved && interpolationDataSaved.labelColumn || "",
        remainingRows: interpolationDataSaved && interpolationDataSaved.remainingRows.filter((row) => !!(interpolationDataSaved && interpolationDataSaved.removeRows && interpolationDataSaved.removeRows.includes(row))) || [],
        removeRows: interpolationDataSaved && interpolationDataSaved.removeRows || [],
        remainingColumns: [
            ...selectedColumns && selectedColumns.selectedCategoricalColumns,
            ...selectedColumns && selectedColumns.selectedNumericalColumns,
            ...selectedColumns && selectedColumns.selectedTargetColumn,
            ...selectedColumns && selectedColumns.selectedDateTime,
        ],
    });
    react_1.useEffect(() => {
        console.log("interpolationData", interpolationData);
        console.log("interpolationFrequency", interpolationDataSaved);
        setUpdatedInterpolateData(interpolationData);
    }, [interpolationData, setUpdatedInterpolateData]);
    react_1.useEffect(() => {
        setLoading(true);
        const fetchUniqueLabels = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            setLoading(true);
            try {
                const projectDetails = {
                    projectname: projectInfo && projectInfo.projectname,
                    problemtype: projectInfo && projectInfo.problemtype,
                    version_name: projectInfo && projectInfo.version_name,
                    userid: js_cookie_1.default.get('USER_ID'),
                    label_column: "labels",
                };
                const uniqueLabelsRes = yield api_1.getUniqueLabels(projectDetails);
                setInterpolationData((prevData) => (Object.assign({}, prevData, { remainingRows: uniqueLabelsRes.data.unique_labels.filter((row) => !(interpolationDataSaved && interpolationDataSaved.interpolationData && interpolationDataSaved.interpolationData.removeRows && interpolationDataSaved.interpolationData.removeRows.includes(row))), interpolationBase: uniqueLabelsRes.data.interpolationbase[0] || "" })));
                setInterpolationData((prevData) => (Object.assign({}, prevData, { interpolationBase: uniqueLabelsRes.data.interpolationbase })));
            }
            catch (error) {
                console.error("Error fetching unique labels:", error);
            }
            finally {
                setLoading(false);
            }
        });
        setLoading(false);
        fetchUniqueLabels();
    }, [projectInfo]);
    const handleDropdownChange = (e, field) => {
        setInterpolationData((prev) => (Object.assign({}, prev, { [field]: e.target.value })));
    };
    const handleMultiSelectChange = (value) => {
        setInterpolationData((prev) => (Object.assign({}, prev, { removeRows: value, remainingRows: prev.remainingRows.filter((r) => !value.includes(r)) })));
    };
    const removeRow = (index) => {
        const newRows = [...interpolationData.removeRows];
        const removedRow = newRows.splice(index, 1)[0];
        setInterpolationData((prev) => (Object.assign({}, prev, { removeRows: newRows, remainingRows: [...prev.remainingRows, removedRow] })));
    };
    return (react_1.default.createElement(core_1.Grid, { container: true },
        loading && (react_1.default.createElement("div", { style: {
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(128, 128, 128, 0.7)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            } },
            react_1.default.createElement(react_spinners_1.PropagateLoader, { color: "#3f51b5" }))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 }),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 8, lg: 8, style: { backgroundColor: "white", padding: "30px" } },
            react_1.default.createElement(core_1.Typography, { variant: "h6" }, "Interpolation Step"),
            react_1.default.createElement("br", null),
            react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Interpolation Base"),
            react_1.default.createElement(core_1.TextField, { select: true, fullWidth: true, value: interpolationData.interpolationBase, style: { marginBottom: "15px" }, onChange: (e) => handleDropdownChange(e, "interpolationBase") }, (interpolationData.remainingColumns || []).map((column) => (react_1.default.createElement(core_1.MenuItem, { key: column, value: column }, column)))),
            react_1.default.createElement("br", null),
            react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Interpolation Frequency"),
            react_1.default.createElement(core_1.TextField, { fullWidth: true, type: "number", value: interpolationData.interpolationFrequency, style: { marginBottom: "15px" }, error: interpolationFrequencyError !== "", helperText: interpolationFrequencyError, onChange: (e) => setInterpolationData((prev) => (Object.assign({}, prev, { interpolationFrequency: parseInt(e.target.value, 10) }))), inputProps: { min: 1 } }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Label Column"),
            react_1.default.createElement(core_1.TextField, { select: true, fullWidth: true, value: interpolationData.labelColumn, style: { marginBottom: "15px" }, onChange: (e) => handleDropdownChange(e, "labelColumn") }, interpolationData.remainingColumns.map((column) => (react_1.default.createElement(core_1.MenuItem, { key: column, value: column }, column)))),
            react_1.default.createElement("br", null),
            react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Remove Rows"),
            react_1.default.createElement(multi_valued_text_field_1.MultiValuedTextField, { columns: interpolationData.removeRows, existingColumns: interpolationData.remainingRows, addColumns: (v) => handleMultiSelectChange(v), removeColumn: (i) => removeRow(i) }),
            react_1.default.createElement(core_1.Typography, { variant: "subtitle1" }, "Remaining Rows"),
            react_1.default.createElement("div", null, interpolationData.remainingRows.map((r, j) => (react_1.default.createElement(core_1.Chip, { label: r, key: j, style: { margin: "5px" } }))))),
        react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 12, md: 2, lg: 2 })));
}
exports.PreprocessingStep3AnomalyDetection = PreprocessingStep3AnomalyDetection;
//# sourceMappingURL=pre-processing-step3-Anomaly.js.map